// extracted by mini-css-extract-plugin
export default {"storeOptionLabel":"UserSelectionList_storeOptionLabel__hxeJ7","storeOptionText":"UserSelectionList_storeOptionText__Uohiw"};